// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nimg[data-v-33c0cb7c] {\n  -o-object-fit: cover;\n     object-fit: cover;\n}\n", ""]);
// Exports
module.exports = exports;
